module.exports = __webpack_public_path__ + "static/media/120.ebc0ede6.webp";